// LeadsTable.js
import React, { useEffect, useState } from "react";

export default function LeadsTable() {
  const [leads, setLeads] = useState([]);

  // 🔹 Carrega os dados da API
  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const res = await fetch("https://receiver-sand.vercel.app/api/form", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        });

        if (!res.ok) throw new Error("Erro ao buscar dados da API");
        const data = await res.json();
        setLeads(data);
      } catch (error) {
        console.error("Erro ao buscar leads:", error);
      }
    };

    fetchLeads();
  }, []);

  // 🔹 Função para deletar lead
  const handleDelete = async (id) => {
    try {
      const res = await fetch("https://receiver-sand.vercel.app/api/form", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }), // ✅ envia o ID no corpo
        mode: "cors",
      });

      if (res.ok) {
        setLeads((prev) => prev.filter((lead) => lead._id !== id));
        alert("✅ Lead deletado com sucesso!");
      } else {
        const data = await res.json();
        alert(`❌ Erro: ${data.error || "Não foi possível deletar o lead"}`);
      }
    } catch (error) {
      console.error("Erro no fetch delete:", error);
      alert("❌ Erro ao deletar lead!");
    }
  };

  return (
    <div style={styles.container}>
      <table style={styles.table}>
        <thead>
          <tr style={styles.headerRow}>
            <th style={styles.th}>Data/Hora</th>
            <th style={styles.th}>Nome</th>
            <th style={styles.th}>Email</th>
            <th style={styles.th}>WhatsApp</th>
            <th style={styles.th}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {leads.length > 0 ? (
            leads.map((lead) => (
              <tr key={lead._id} style={styles.tr}>
                <td style={styles.td}>
                  {new Date(lead.createdAt).toLocaleString("pt-BR")}
                </td>
                <td style={styles.td}>{lead.nome}</td>
                <td style={styles.td}>{lead.email}</td>
                <td style={styles.td}>{lead.whatsapp}</td>
                <td style={styles.td}>
                  <button
                    style={{ ...styles.button, position: "relative", zIndex: 9999 }}
                    onClick={() => handleDelete(lead._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td style={styles.empty} colSpan="5">
                Nenhum lead encontrado
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

// 💅 Estilos
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f8f9fa",
    padding: "20px",
  },
  table: {
    borderCollapse: "collapse",
    width: "90%",
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },
  headerRow: {
    background: "#f1f1f1",
  },
  th: {
    border: "1px solid #ddd",
    padding: "12px",
    textAlign: "center",
    fontWeight: "bold",
  },
  td: {
    border: "1px solid #ddd",
    padding: "12px",
    textAlign: "center",
  },
  tr: {
    backgroundColor: "#fff",
  },
  button: {
    padding: "8px 12px",
    backgroundColor: "#e63946",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  empty: {
    padding: "20px",
    textAlign: "center",
    color: "#777",
  },
};
